import { SeverityLevel } from "@microsoft/applicationinsights-web";
import EnvironmentBase from '../../../../../Frontend/Common/ph-bhp-common-library/Interfaces/Environment/environment-base.interface';

export default interface Environment extends EnvironmentBase {
  /**
   * Configure the connection to application insights
   */
  appInsightsInstrumentationKey?: string;
  /**
   * Minimum level of severity for logs to be send to Application Insights. Defaults to Warning if unset.
   */
  appInsightsMinimumLogLevel?: SeverityLevel;
  siteUrl: string;
  androidUrl: string;
  iosUrl: string;
  helpUrl: string;
  imageUrl: string;
  loginAccesstok: string;
  isUserName: boolean;
  signUpUrl: string;
  PLATFORM_AUTH: string;
  bsCalenderDateConfig: { showWeekNumbers: boolean; containerClass: string; adaptivePosition: boolean; isAnimated: boolean; rangeInputFormat: string };
  consumerKey: string;
  check: CheckEnvironment;
  inactivityModal: InactivityModalTimer;
}

interface CheckEnvironment {
  api_url: string
  signInUrl: string
  refreshTokenUrl: string
  apiHartmannUrl: string
}

interface InactivityModalTimer {
  countdown: number,
  inactivityIntervalTime: number
}

export class Version{
  public static current:string = '2.1.3'
}
